export default __webpack_public_path__ + "static/media/like.efb8b04e.svg";